import { render, staticRenderFns } from "./TxItem.vue?vue&type=template&id=418c7252&scoped=true"
import script from "./TxItem.vue?vue&type=script&lang=js"
export * from "./TxItem.vue?vue&type=script&lang=js"
import style0 from "./TxItem.vue?vue&type=style&index=0&id=418c7252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418c7252",
  null
  
)

export default component.exports